import React from 'react';
import Grid from "@mui/material/Grid2";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './ProductSlider.css';
import BannerImage1 from '../../assets/images/product-1.png';
import BannerImage2 from '../../assets/images/product-2.png';
import { Container } from '@mui/material';

const ProductSlider = () => {
  const slides = [
    {
      title: 'Purchase Products',
      description: 'Find the steel you need!',
      buttonText: 'Enquiry Now',
      imageUrl: BannerImage1
    },
    {
      title: 'Sell & Purchase Products',
      description: 'Experience seamless steel trading with Steel Buddy—buy, sell, and succeed on a trusted digital platform!',
      buttonText: 'Enquiry Now',
      imageUrl: BannerImage2
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    cssEase: 'linear'
  };

  return (
    <section className="product-slider-container">


        <Container maxWidth="lg">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div key={index} className="product-slide">


<Grid className="slide-content" container spacing={2} justifyContent="space-between" alignItems="center">


<Grid size={{ xs: 12, md: 4 }} order={{ xs: 1, md: 2 }}>
                
                <div className="content-right">
                    <img 
                      src={slide.imageUrl} 
                      alt={slide.title} 
                      className="slide-image"
                    />
                  </div>
                   </Grid>

              <Grid size={{ xs: 12, md: 6 }} order={{ xs: 2, md: 1 }}>
              <div className="content-left">
                  <h3 className='page-title'>{slide.title}</h3>
                  <p>{slide.description}</p>
                  {/* <div className='slide-button'>
                    <a className="enquiry-button" href='/enquiry'>{slide.buttonText}</a>
                  </div> */}
                </div>
                
                 </Grid>
            
              </Grid>

            


            </div>
          ))}
        </Slider>
        </Container>
      
    </section>
  );
};

export default ProductSlider; 